import { registry } from '@wix/editor-elements-registry/2.0/thunderbolt'
import { createComponentsRegistryCSRFactory, type IComponentsRegistryCSR } from './clientBase'

export type { IComponentsRegistryCSR }
export const createComponentsRegistryCSR = createComponentsRegistryCSRFactory(registry)
